export const DEPARTMENT_LEADER = 16
export const STAFF = 14
export const LEADER_GROUP = 34
export const LEADER = 32
